import common from "../common";

export default class PencilTransition extends P3.Transition {
    constructor(duration = 0.8) {
        super();
        this._duration = duration;
        this._scrollSpeed = 0;
    }

    init() {
        super.init();

        this._holder = new PIXI.Container();
        this.addChild(this._holder);

        this._bg = new PIXI.TilingSprite(P3.assets.texture("bg_main"), common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this._holder.addChild(this._bg);

        this._bg.tilePosition = common.tilePosition;

        this._pencil = new PIXI.Sprite(P3.assets.texture("pencil"));
        this._pencil.anchor.set(0.5);
        this._pencil.scale.set(0.5);
        this._pencil.position.set(common.STAGE_WIDTH / 2, common.STAGE_HEIGHT / 2);
        this._pencil.visible = false;
        this._holder.addChild(this._pencil);

        // fake an update loop
        this._updateTween = new P3.utils.TWEEN.Tween({}).to({}, Infinity).onUpdate(() => this.update()).start();

        this.resize();
    }

    destroy(params) {
        this._updateTween.stop();
        super.destroy(params);
    }

    update(dt = window.deltaTime) {
        common.tilePosition.x += this._scrollSpeed * dt;
        common.tilePosition.y -= this._scrollSpeed * dt;
        this._bg.tilePosition = common.tilePosition.clone();
    }

    resize() {
        super.resize();
        this.x = (P3.View.width - common.STAGE_WIDTH) * 0.5;
    }

    in(delay = 0) {
        new P3.utils.TWEEN.Tween(this._pencil)
            .to({rotation: Math.PI * 2}, (this._duration + 1) * 1000)
            .delay(delay * 1000)
            .easing(P3.utils.TWEEN.Easing.Linear.None)
            .start();

        this._holder.alpha = 0;
        new P3.utils.TWEEN.Tween(this._holder)
            .to({alpha: 1}, this._duration * 0.5 * 1000)
            .delay(delay * 1000)
            .easing(P3.utils.TWEEN.Easing.Cubic.InOut)
            .onComplete(() => this.signals.in.dispatch(this))
            .start();
    }

    out(delay = 0) {
        new P3.utils.TWEEN.Tween(this._holder)
            .to({alpha: 0}, this._duration * 0.5 * 1000)
            .delay(delay * 1000)
            .easing(P3.utils.TWEEN.Easing.Cubic.InOut)
            .onComplete(() => {
                common.tilePosition = this._bg.tilePosition.clone();
                this.signals.out.dispatch(this);
            })
            .start();
    }
}